// Filename: models/questionnaire/questionnaire.js
define('models/questionnaire/option',[
    'underscore',
    'backbone',
    // src
    'utils',
    'services/api',
], function(_, Backbone, U, API) {

    var MOption = Backbone.Model.extend({

        defaults: {
            text: "",
        },

        initialize: function(text) {
            this.set("text", text);
        },
    });

    // Return the model for the module
    return MOption;
});

